<template>
  <div class="history-btn">
    <img v-show="showBtn" src="@/assets/images/common-icons/icon_history.svg" class="history_icon"
         @click="openHistoryModal">
  </div>
</template>

<script>
  export default {
    name: 'HistoryModalGridButton',
    data() {
      return {}
    },
    methods: {
      openHistoryModal() {
        this.$root.$emit('openHistoryModal', {
          url: `${this.params.data.url_name}/?id=${this.params.data.id}`,
          title: this.params.data.history_title
        });
      }
    },
    computed: {
      showBtn() {
        return !this.params.node.rowPinned && this.params.data && this.params.data.id;
      }
    }
  }
</script>

<style scoped>
  .history-btn {
    text-align: center;
  }

  .history_icon {
    width: 20px;
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/HistoryModalGridButton.vue